/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins'

// Components
import App from './App.vue'


// Composables
import { createApp } from 'vue'
import store from './store';
import router from './router';

import VueGtag from "vue-gtag-next";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faUser, faFileAlt, faUnlink, faDatabase } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { AppEnvironments, GoogleAnalyticsPropertyConfig } from './constants';
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import JsonExcel from "vue-json-excel3";
import mitt from 'mitt';
import Notifications from '@kyvg/vue3-notification';


export const agentBus = mitt();
const app = createApp(App);
const env = getEnvironment();

app.config.globalProperties.emitter = agentBus;

library.add(faCoffee, faUser, faFileAlt, faUnlink, faDatabase);
app.component('font-awesome-icon', FontAwesomeIcon)
app.component("downloadExcel", JsonExcel);

// This module is not use in code
// import VueTruncate from "vue-truncate-filter";
// Vue.use(VueTruncate)
// app.use(VueMaterial);

app.use(Notifications);

if (env != AppEnvironments.CTDStaging) {
  app.use(VueGtag, {
    property: GoogleAnalyticsPropertyConfig,
    useDebugger: env == AppEnvironments.Development ? true :false
  });
} 
// app.use(VueGtag, {
//   config: { id: "UA-129331363-1" },
//   includes: [
//     { id: '185124118' }
//   ]
// }, router);



app.use(store)

app.directive('focus', {
  // When the bound element is mounted into the DOM...
  mounted(el) {
    // Focus the element
    el.focus()
  }
})


store.subscribe((mutation, state) => {
  localStorage.setItem('store', JSON.stringify(state));
});


Sentry.init({
  app,
  dsn: "https://92f55895f39441db8316679ea80e325c@o335354.ingest.sentry.io/5289148",
  release: `ActionList-UI@${process.env.npm_package_version}`,
  trackComponents: true,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "actionlistctd.greenstonesystems.com", "actionlist.greenstonesystems.com", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  environment: getEnvironment(),

});

const ignoreResizeObserverError = (err:any) => {
  if (err.message === "ResizeObserver loop completed with undelivered notifications") {
    return;
  }
  throw err;
};
window.addEventListener('error', ignoreResizeObserverError);

registerPlugins(app)
app.mount('#app')


function getEnvironment() {
  let url = window.location.host;
  let env = "";
  if (process.env.NODE_ENV === AppEnvironments.Production) {
    if (url.indexOf("actionlistctd") !== -1)
      env = AppEnvironments.CTDStaging;
    else env = AppEnvironments.Production;
  }
  else if (url.indexOf("localhost") !== -1) {
    env = AppEnvironments.Development
  }
  else env = AppEnvironments.Development;
  // console.log(`App Environemnt => ${process.env.NODE_ENV}`);
  // console.log(`Environemnt => ${env}`);
  return env;
}
